module.exports = __webpack_public_path__ + "img/drugs-black.f19da74e.svg";